import type { FaireProductEntity } from "../../entity_types/product";

export const p_yvdraembyp: FaireProductEntity = {
  token: "p_yvdraembyp",
  type: "product",
  name: "Natural Crystals Dice 16mm Healing Energy",
  brandToken: "b_edj9u7j4sq",
  brandName: "KayleeNYC",
  imageUrl: "https://cdn.faire.com/fastly/d7c987d03033e4b0068f2faf333030c07d1e26622feb72158dad6b88945db894.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/31b03fe7407dd249919d1efd903054395652b85ab223483619de750fee7c427a.jpeg",
    "https://cdn.faire.com/fastly/c102e009b1e2d1f222d3e0f06bbaee874f56304527a585600947e2c328409c27.jpeg",
    "https://cdn.faire.com/fastly/7497cb2aa4bad2eef155b1c08a63d446093c1d4d8310b84c135e8b4a87668cae.jpeg",
    "https://cdn.faire.com/fastly/657a08c31ddd76bf7d9fbd7847a89242dfb1605fdb8321e9ad04dd76a7fba132.jpeg",
    "https://cdn.faire.com/fastly/b98ef4558b386783c45be7fea9eb8e24dd10c72662b2ba55e5d4b55972b019ad.jpeg",
    "https://cdn.faire.com/fastly/5c2b50b2573d55697617e73d256e54189bf26677ba19b1df1d6827698f2b487f.jpeg",
    "https://cdn.faire.com/fastly/2d7266c049f8d887486b8d7df026e3480ba90f04f748924446a30fa276ef51cb.jpeg",
    "https://cdn.faire.com/fastly/edf3c72e80b8dfcd44b1e2e3c3dcfa2438f5a6a58d7bb316ff801940e96278d3.jpeg"
  ],
  priceDollars: 2.7,
  description: "Add a unique and eye-catching assortment to your inventory with these hand-carved natural crystal dices. Each piece is carefully shaped and polished, showcasing the natural beauty and variations of genuine gemstones.\n\nThis 24-piece set includes a balanced mix of popular crystals:\n\t•\tAmethyst\n\t•\tAventurine\n\t•\tRose Quartz\n\t•\tClear Quartz\n\t•\tTiger Eye\n\nEach dice measures approximately 16mm, making them ideal for collectors, game enthusiasts, gift sets, or metaphysical use.\n\nDue to the natural properties of the stones, each piece may feature unique variations in color, pattern, and minor inclusions, enhancing their individual character.\n\nCondition: New\nMinimum order 24 pieces \n\nLocal pickup is available in Brooklyn, New York. \n\nStones, stone, crystal, crystals, crystals bulk, crystals wholesale, spiritual, spiritual items, meditation, metaphysical wholesale.",
  tags: [],
  msrpDollars: 5.4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:00:11.648Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
